import { Sort } from '@urc-ui/store/api/ross/types/types';

export const DEFAULT_ROSS_SORT_CONFIG: Sort = {
  column: 'ModifiedOn',
  direction: 'Desc'
};
